// geojsonSaga.js
import { put, takeLatest, call } from 'redux-saga/effects';
import axios from 'axios';
import { fetchDataStart, fetchDataSuccess, fetchDataFailure } from './geojsonSlice';
import { featureCollection, point } from 'geojson';

function* fetchGeoJSONData(action) {
  try {
    // Dispatch the 'fetchDataStart' action to set the loading state to true
    // yield put(fetchDataStart());
    yield put(fetchDataSuccess(true));

    // Make the API call to retrieve the data
    const response = yield call(axios.get, action.payload);
    console.log(response.data.result.objects.output,"SAGA RESPONSE");
    // Transform the API data into GeoJSON format
    const features = response.data.Infogempa.gempa.map(item => {
      const longitude = parseFloat(item.point.coordinates[0]);
      const latitude = parseFloat(item.point.coordinates[1]);
      const magnitude = parseFloat(item.Magnitude);
      const location = item.Wilayah;

      return point([longitude, latitude], { magnitude, location });
    });
console.log("features::", features)
    const geojson = featureCollection(features);
console.log(geojson, "GEOJSONSAGASSS");
    // Dispatch the 'fetchDataSuccess' action with the transformed GeoJSON data
    yield put(fetchDataStart(geojson));
    yield put(fetchDataSuccess(true));

  } catch (error) {
    // Dispatch the 'fetchDataFailure' action if there's an error
    yield put(fetchDataFailure(error.message));
    yield put(fetchDataSuccess(false));
  }
}

export default function* mapSaga() {
  yield takeLatest('map/fetchMapDetails', fetchGeoJSONData);
}